import { api } from './api';
import {
  ResidenceReviewListResponse,
  ResidenceGateResponse,
  ResidenceRecheckResponse,
  ReviewResidenceDocumentRequest,
} from '@mygate/common';

/**
 * Backoffice service for the post-KYC residence document review (MYG-341).
 */
class ResidenceReviewService {
  /**
   * scope 'pending' = open queue; 'all' = recent runs of any status, incl. auto-approved (MYG-982).
   * Optional server-side search (name or exact user id) and pagination.
   */
  async listReviews(
    scope: 'pending' | 'all' = 'pending',
    params: { page?: number; limit?: number; search?: string } = {},
  ) {
    const qs = new URLSearchParams();
    if (scope === 'all') qs.set('scope', 'all');
    if (params.page) qs.set('page', String(params.page));
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.search?.trim()) qs.set('search', params.search.trim());
    const q = qs.toString();
    const response = await api.get<ResidenceReviewListResponse>(`/api/staff/residence/reviews${q ? `?${q}` : ''}`);
    return response.data;
  }

  /** ACCEPT (unlocks the app) or REJECT (with a reason → user re-uploads). Works on any case (MYG-982). */
  async review(userId: string, body: ReviewResidenceDocumentRequest) {
    const response = await api.post<ResidenceGateResponse>(`/api/staff/residence/reviews/${userId}`, body);
    return response.data;
  }

  /** Re-run the STACKIT vision check for a user's uploaded document (MYG-982). */
  async recheck(userId: string) {
    const response = await api.post<ResidenceRecheckResponse>(`/api/staff/residence/reviews/${userId}/recheck`, {});
    return response.data;
  }

  /** The uploaded document (image or PDF) for side-by-side name comparison. */
  getDocument(userId: string): Promise<Blob> {
    return api.fetchBlob(`/api/staff/residence/reviews/${userId}/document`);
  }
}

export const residenceReviewService = new ResidenceReviewService();
